import { connect } from 'react-redux';
import * as actions from './actions';
import ActivityLogs from './ActivityLogs';

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingList: state.activityLogs.isFetchingList,
    activityLogs: state.activityLogs.activityLogs,
    errors: state.activityLogs.errors,
    success: state.activityLogs.success,
    hasServerError: state.activityLogs.hasServerError,
    view: state.loginLayout.view,
    ...ownProps
  };
};

const mapDispatchToProps = dispatch => ({
  fetchActivityLogs: (token) => dispatch(actions.fetchActivityLogs(token)),
  clearErrors: () => dispatch(actions.clearErrors()),
  filterLogs: (conference, webinar, startDate, endDate, keyword) => dispatch(actions.filterLogs(conference, webinar, startDate, endDate, keyword)),
});

const ActivityLogsContainer = connect(mapStateToProps, mapDispatchToProps)(
  ActivityLogs,
);

export default ActivityLogsContainer;



// WEBPACK FOOTER //
// src/routes/ActivityLogs/ActivityLogsContainer.js